import React from "react";
import { AutoResizeTextarea } from "@/components/Common/AutoResizeTextarea";

export const EtcInfo = ({ formData, handleChange, setFormData }) => {
    const { memoForContract } = formData;

    return (
        <>
            {/* 메모 */}
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>메모</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <AutoResizeTextarea
                            name="memoForContract"
                            placeholder="메모를 작성해주세요."
                            value={memoForContract}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
